<div class="visualization-posts-bottom-sheet" fxLayout="column">
    <div
        class="visualization-posts-bottom-sheet__header"
        fxLayout="row"
        fxLayoutAlign="start center"
    >
        <span style="width: 42px"></span>
        <h4 class="text-14-semi-bold text-center color-text-hint" fxFlex>
            Comentários
        </h4>
        <dsn-button-rounded
            type="secondary"
            icon="fa-solid fa-xmark"
            size="large"
            (onClick)="onCloseBottomSheet()"
        ></dsn-button-rounded>
    </div>

    <div
        class="visualization-posts-bottom-sheet__comments"
        fxLayout="column"
        fxFlex
    >
        <app-comments-post
            [company]="data.company"
            [report]="data.report"
            [options]="data.options"
            [visualization]="data.visualization"
            style="height: 100%"
            [isMobileComment]="true"
        ></app-comments-post>
    </div>
</div>
